import { createContext, FC, ReactNode, useContext } from "react";

import { IDropdownItemStations, SKIP_HUB_ID } from "@ryde/shared";

export { SKIP_HUB_ID };

export interface IHubStationsContextValue {
  hubStationsDropdownList: IDropdownItemStations[];
  isHubStationsLoading: boolean;
}

const HubStationsContext = createContext<IHubStationsContextValue | null>(null);

export const useHubStationsContext = (): IHubStationsContextValue | null =>
  useContext(HubStationsContext);

export interface IHubStationsProviderProps {
  value: IHubStationsContextValue;
  children: ReactNode;
}

export const HubStationsProvider: FC<IHubStationsProviderProps> = ({
  value,
  children,
}) => (
  <HubStationsContext.Provider value={value}>
    {children}
  </HubStationsContext.Provider>
);
